import { useAppSelector } from 'hooks/reduxHooks'

// Campaign end date: 5 Jan 2026, 11:59pm AEST (UTC+11)
const MALDIVES_BANNER_END_DATE_MS = new Date('2026-01-06T00:00:00+11:00').getTime()

/**
 * Hook to determine if the Maldives Charter banner should be shown.
 * Shows for AU users until 5 Jan 2026.
 */
export function useShowMaldivesBanner(): boolean {
  const currentRegionCode = useAppSelector(state => state.geo.currentRegionCode)
  const isAU = currentRegionCode === 'AU'
  return isAU && Date.now() < MALDIVES_BANNER_END_DATE_MS
}
